import AuthContext from "../context/authContext";
import { useNavigate, useLocation } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { delDisableEntity, getEntities, setEnableEntity } from "../helpers/tableauUserHelpers";
import {Tab,  Tabs, TabList, TabPanel } from "react-tabs";

import AddEntityModal from "./addEntityModal"
import UserSettings from "./userSettings";

import logo from "../content/img/logo-header.png";
import logoutImg from "../content/img/exit.png";
import { BsFillTrashFill, BsFillPencilFill} from "react-icons/bs";

import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";
import 'react-tabs/style/react-tabs.css';
import '../content/ccbh-tableau-portal_2.0.css';
import './addEditEntities.css';

const AddEditEntity = () => {
    let navigate = useNavigate();
    const { logout } = useContext(AuthContext);
    const location = useLocation();

    const [entities, setEntites] = useState([]);
    const [selectedEntity, setSelectedEntity] = useState(null);
    const [openAddEntityModal, setOpenAddEntityModal] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);

    const fetchEntities = async() => {
        return await getEntities('A');
    };

    const fetchDelDisableEntity = async(entityId, disable) =>{
        return await delDisableEntity(entityId, disable);
    };

    const fetchSetEnableEntity = async(entityId) => {
        return await setEnableEntity(entityId);
    };

    const deleteEntity = (entityId) => {
        if(entityId === "0"){
            ccbhmessagebox({
                message: "This Entity Account Can not be deleted. Contact the application owner if you are trying to delete this account.",
                title: "CZAR account deletion",
                modal: true,
                closebutton: false,
                buttons:{
                    'Ok': function() {
                        removeMsg();
                    }
                }
            });
        }else{
            ccbhmessagebox({
                message: "Are you sure you want to delete this entity? If so click DELETE. If you want to disable the Entity click DISABLE. Delete will remove the entity and all users associated from the database.",
                title: "Delete Entity",
                modal: true,
                closebutton: false,
                buttons: {
                    'Delete': function(){
                        fetchDelDisableEntity(entityId, 'N');
                        removeMsg();
                    },
                    'Disable': function(){
                        fetchDelDisableEntity(entityId, 'Y');
                        removeMsg();
                    },
                    'Cancel' : function(){
                        removeMsg();
                    }
                }
            });
        }
    };

    const flipEntityActive = (entityId, isActive) => {
        if(entityId === "0"){
            ccbhmessagebox({
                message: "This Entity Account Can not be enabled or disabled. Contact the application owner if you are trying to edit this account.",
                title: "CZAR account notice",
                modal: true,
                closebutton: false,
                buttons:{
                    'Ok': function() {
                        removeMsg();
                    }
                }
            });
        }else if(isActive){
            ccbhmessagebox({
                message: "Are you sure you want to disable this entity?",
                title: "Disable Entity",
                modal: true,
                closebutton: false,
                buttons: {
                    'Yes': function(){
                        fetchDelDisableEntity(entityId, 'Y');
                        
                        ccbhmessagebox({
                            message:"Entity Disabled",
                            title: "Enable Entity",
                            modal: true,
                            closebutton: false,
                            buttons:{
                                'Ok' : function(){
                                    removeMsg();
                                    refreshTable();
                                }
                            }
                        });

                    },
                    'Cancel' : function(){
                        removeMsg();
                    }
                }
            });
        }else{
            ccbhmessagebox({
                message: "Are you sure you want to enable this entity?",
                title: "Enable Entity",
                modal: true,
                closebutton: false,
                buttons: {
                    'Yes': function(){
                        fetchSetEnableEntity(entityId);
                        
                        ccbhmessagebox({
                            message:"Entity Enabled",
                            title: "Enable Entity",
                            modal: true,
                            closebutton: false,
                            buttons:{
                                'Ok' : function(){
                                    removeMsg();
                                    refreshTable();
                                }
                            }
                        });
                        
                    },
                    'Cancel' : function(){
                        removeMsg();
                    }
                }
            });
        }
    };

    const getEntityInformation = (entityId) => {
        console.debug('Get Entity Information: Edit Entity Screen');
        if(entityId === "0"){
            ccbhmessagebox({
                message: "This Entity Account Can not be Edited. Contact the application owner if you are trying to edit this account.",
                title: "CZAR Account Editing",
                modal: true,
                closebutton: false,
                buttons:{
                    'Ok': function() {
                        removeMsg();
                    }
                }
            });
        }else{
            const entity = entities.find((ent) => {
                if(ent.id === entityId){
                    return ent;
                }
            });

            setSelectedEntity(entity);
            setOpenAddEntityModal(true);
        }
    };

    const [currentSortOrder, setCurrentSortOrder] = useState('ascending');
    const onSortColumn = (sortCol) => {
        let sortData = [];
        if(currentSortOrder === 'ascending'){
            if(sortCol === 'entityId'){
                sortData = [...entities].sort((a,b) => (b.id.localeCompare(a.id)));
            }else if(sortCol === 'entityName'){
                sortData = [...entities].sort((a,b) => (b.name.localeCompare(a.name)));
            }else if(sortCol === 'entityType'){
                sortData = [...entities].sort((a,b) => (b.typeDescription.localeCompare(a.typeDescription)));
            }else if(sortCol === 'active'){
                sortData = [...entities].sort((a,b) => (b.enabled - a.enabled));
            }
            setCurrentSortOrder('decending');
        }else{
            if(sortCol === 'entityId'){
                sortData = [...entities].sort((a,b) => (a.id.localeCompare(b.id)));
            }else if(sortCol === 'entityName'){
                sortData = [...entities].sort((a,b) => (a.name.localeCompare(b.name)));
            }else if(sortCol === 'entityType'){
                sortData = [...entities].sort((a,b) => (a.typeDescription.localeCompare(b.typeDescription)));
            }else if(sortCol === 'active'){
                sortData = [...entities].sort((a,b) => (a.enabled - b.enabled));
            }
            setCurrentSortOrder('ascending');
        }
        setEntites(sortData);
    };

    function userLogout(){
        console.log("User clicked Logout");
        logout();
        navigate("/", {state: {id:3, name:"SessionTimeOut", loginResult: null}});
    };
    
    const addNewEntity = () =>{
        setSelectedEntity(null);
        //setOpenAddEditUserModal(false);
        setOpenAddEntityModal(true);
    };
    
    const refreshTable = async() => {
        fetchEntities().then((et) => {
            setEntites(et);
            console.log('refresh table entities:', et);
        });
    };

    useEffect(() => {
        fetchEntities().then((et) => {
            setEntites(et);
            console.log('fetched entities:', et);
        });
    }, []);

    return (
        <>
           <Container className="userSettingsPage">
                <div id="vertical-nobar" className="czar-bar" name="top-bar" hidden>
                    <img id="logo" name="logo" src={logo} alt="Community Care Behavioral Health Organization"  />
                    <span id="left-side-vertical-app-buttons">
                        <hr id="menuHr" width="90%" />
                        <span className="left-side-button" onClick={() => userLogout()} >
                            <img id="user-logout" className="button-img-exit" src={logoutImg} alt="Logout Button"/>
                            <label className="nav-label">Log Out</label>
                        </span>
                    </span>
                </div> 
                <div id="czar-inner-page">
                    <Tabs id="admin-account-settings-bar" selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
                        <TabList id="inner_nav_div">
                            <Tab className="pageLink" id="admin-account-info" title="Switch to Entity Administration View" >
                                Entities
                            </Tab>

                            <Tab className="pageLink" id="admin-employee-account" title="Switch To User Account Administration View" >
                                User Accounts 
                            </Tab>
                        </TabList>
                        <TabPanel>
                            <div className="" id="admin-user-accounts">
                                <input type="button" id="add-entity" title="Add A New Entity" value="Add Entity" onClick={() => {addNewEntity();} } />
                                <input type="button" id="refresh-table" title="Refresh User List" value="Refresh" onClick={() => {refreshTable();}} />

                                <h3 className="">Entities: {entities?.length}</h3>
                                <div className="shadow-talk-modal">
                                    <table id="direct-reports" class="entities">
                                        <tr>
                                            <th className="sortable" onClick={() => {onSortColumn('entityId');}}>Entity ID</th>
                                            <th className="sortable" onClick={() => {onSortColumn('entityName');}}>Entity Name</th>
                                            <th className="sortable center" onClick={() => {onSortColumn('entityType');}}i>Entity Type</th>
                                            <th className="sortable center" onClick={() => {onSortColumn('active');}}>Active</th>
                                            <th className="center">Actions</th>
                                        </tr>

                                        {entities?.map(e =>{
                                            let isActive = "";
                                            if(e.enabled === true){
                                                isActive = "checked";
                                            }
                                            
                                            return(
                                                <>
                                                <tr className="">
                                                        <td className="" name="entity-id">
                                                            {e.id}
                                                        </td>
                                                        <td className="" name="entity-name">
                                                            {e.name}
                                                        </td>
                                                        <td className="center" name="">
                                                            {e.typeDescription}
                                                        </td>
                                                        <td className="center" name="">
                                                            <input type="checkbox" id="entity-active" checked={isActive} onClick={() => {flipEntityActive(e.id, isActive);}}  />
                                                        </td>
                                                        <td className="center" >
                                                                <span title="Delete Entity" id="delete-user-img" >
                                                                    <BsFillTrashFill onClick={() => {
                                                                        deleteEntity(e.id);
                                                                    }} 
                                                                    />
                                                                </span>
                                                                <span title="Edit Entity" id="edit-user-img" >
                                                                    <BsFillPencilFill onClick={() => {
                                                                        getEntityInformation(e.id);         
                                                                    }} />
                                                                </span>
                                                        </td>
                                                    </tr> 
                                                </>
                                            );
                                            })
                                        }
                                    </table>
                                </div>
                            </div>
                        </TabPanel>
                        
                        <TabPanel>
                            <UserSettings
                                showPageHeader={false}
                                userModalMode="Add"
                            />
                        </TabPanel>
                    </Tabs>
                </div>
            </Container>
            {openAddEntityModal && 
                <AddEntityModal closeModal={() => {
                    setOpenAddEntityModal(false);
                    fetchEntities().then((et) => {
                        setEntites(et);
                        console.log('close fetched entities:', et);
                    });

                    }}
                    selectedEntity={selectedEntity}
                    
                />
            }
        </>
    );
}

export default AddEditEntity;